import React, { FC, useEffect, useMemo } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useServiceModeContext } from 'state/service-mode';
import { useStoreContext } from 'state/store';
import { isCateringPickup } from 'utils/service-mode';

import { BottomServiceModeRedesignView } from './bottom-service-mode-redesign.view';
import { BottomServiceModeView } from './bottom-service-mode.view';
import { useBottomServiceModeDetails } from './hooks/use-bottom-service-details';
import { useRoutesDisplayBottomService } from './hooks/use-routes-display-bottom-service';
import { IBottomServiceModeProps } from './types';

const StickyBottomServiceMode = styled(BottomServiceModeView)`
  z-index: ${Styles.zIndex.overlay + 100};
  width: 100%;
`;

const StickyBottomServiceModeRedesign = styled(BottomServiceModeRedesignView)`
  z-index: ${Styles.zIndex.overlay + 100};
  width: 100%;
`;

/**
 *
 * BottomServiceMode purpose
 *
 */
const BottomServiceMode: FC<IBottomServiceModeProps> = () => {
  const enableBottomServiceMode = useFlag(LaunchDarklyFlag.ENABLE_BOTTOM_SERVICE_MODE);
  const bottomServiceModeDetails = useBottomServiceModeDetails();
  const { CancellationModal, ConfirmationModal } = bottomServiceModeDetails;
  const showBottomServiceOnRoutes = useRoutesDisplayBottomService();
  const isLocatorUIRefreshEnabled = useFlag(LaunchDarklyFlag.ENABLE_LOCATOR_UI_REFRESH);
  const enableOrdering = useFlag(LaunchDarklyFlag.ENABLE_ORDERING);
  const isWebCateringEnabled = useFlag(LaunchDarklyFlag.ENABLE_WEB_CATERING);
  const { resetStore } = useStoreContext();
  const { serviceMode } = useServiceModeContext();

  const { formatMessage } = useIntl();

  const isDisplayBottomServiceMode = useMemo(
    () => enableBottomServiceMode && showBottomServiceOnRoutes,
    [enableBottomServiceMode, showBottomServiceOnRoutes]
  );

  useEffect(() => {
    if (!enableOrdering) {
      resetStore();
    }
  }, [enableOrdering, resetStore]);

  if (!isDisplayBottomServiceMode) {
    return null;
  }

  return (
    <>
      {isWebCateringEnabled && isCateringPickup(serviceMode) ? (
        <StickyBottomServiceModeRedesign {...bottomServiceModeDetails} />
      ) : (
        <StickyBottomServiceMode
          isLocatorUIRefreshEnabled={isLocatorUIRefreshEnabled}
          {...bottomServiceModeDetails}
        />
      )}

      <CancellationModal />

      <ConfirmationModal
        heading={formatMessage({ id: 'bsmConfirmationModalHeading' })}
        body={formatMessage({ id: 'bsmConfirmationModalBody' })}
      />
    </>
  );
};

export default BottomServiceMode;
